module.exports = __webpack_public_path__ + "static/media/settings.ab84c14e.svg";